export default {
    bind: function (el, binding, vnode) {
        // 在指令绑定时设置元素基本样式 - 已经在css里设置
        // 利用Vue的生命周期钩子函数监听用户的鼠标事件
        el.addEventListener('mousedown', function (event) {
            let disX = event.clientX - el.offsetLeft;
            let disY = event.clientY - el.offsetTop;
            document.addEventListener('mousemove', move);
            document.addEventListener('mouseup', up);
            function move(event) {
                el.style.left = event.clientX - disX + 'px';
                el.style.top = event.clientY - disY + 'px';
            }
            function up(event) {
                document.removeEventListener('mousemove', move);
                document.removeEventListener('mouseup', up);
            }
        });
    }
    
}



// WEBPACK FOOTER //
// ./src/directive/drag.js